import { createSlice } from '@reduxjs/toolkit';

import { Tombstone } from '@/features/deleted/deletedApi';

export interface DeletedScope {
  items:			Tombstone[];
  loaded:			boolean;
}

export interface DeletedState {
  scopes:			{ [key: string]: DeletedScope };
}

export function deletedScopeKey(kind: string, hotelId?: string): string {
  return kind + "|" + (hotelId || "");
}

const initialState: DeletedState = { scopes: {} };

export const deletedSlice = createSlice({
  name: 'deleted',
  initialState,
  reducers: {
    setItems: (state, action) => {
      state.scopes[action.payload.key] = {
        items:		action.payload.items,
        loaded:		true,
      };
    },
    // Restore and purge both consume the tombstone, so both drop the row.
    dropItem: (state, action) => {
      const scope = state.scopes[action.payload.key];
      if (!scope)
        return;

      scope.items = scope.items.filter((it: Tombstone) => it.id !== action.payload.id);
    },
    clearScope: (state, action) => {
      delete state.scopes[action.payload];
    },
    clearAll: (state) => {
      state.scopes = {};
    },
  },
});

const emptyScope: DeletedScope = { items: [], loaded: false };

export function selectDeletedScope(state: DeletedState, kind: string, hotelId?: string): DeletedScope {
  return state.scopes[deletedScopeKey(kind, hotelId)] || emptyScope;
}
